export const Loading = "loading"
export const Show = "show"
export const Title = "title"
export const Message = "message"
export const Data = "data"
export const Image = "image"
export const Buttons = "buttons"

const state = {
    [Loading]: false,
    [Show] : false,
    [Title] : "",
    [Message] : "",
    [Data] : "",
    [Image] : "",
    [Buttons] : []
}

const getters={
    isLoading(state){
        return state[Loading]
    },
    isShow(state) {
        return state[Show];
    },
    [Message](state){
        return state[Message]
    },
    [Title](state){
        return state[Title]
    },
    [Data](state){
        return state[Data]
    },
    [Image](state){
        return state[Image]
    },
    [Buttons](state){
        return state[Buttons]
    }
}

const mutations = {
    [Loading](state, value){
        state[Loading] = value;
    },
    [Show](state, value){
        state[Show] = value;
    },
    [Message](state, value){
        state[Message] = value;
    },
    [Title](state, value){
        state[Title] = value;
    },
    [Data](state, value){
        state[Data] = value;
    },
    [Image](state, value){
        state[Image] = value;
    },
    [Buttons](state, value){
        state[Buttons] = value;
    }
}

const actions = {
    [Loading](context, value){
        context.commit(Loading, !!value)
    },

    [Show](context, value){
        context.commit(Show, !!value)
    },

    [Message](context, value){
        context.commit(Message, value)
    },

    [Title](context, value){
        context.commit(Title, value)
    },

    [Data](context, value){
        context.commit(Data, value)
    },

    [Image](context, value){
        context.commit(Image, value)
    },

    [Buttons](context, value){
        context.commit(Buttons, value)
    }
}

export default {
    namespaced : true,
    actions,
    getters,
    state,
    mutations
}